export const btnSty = {
  paddingY: 2,
  paddingX: 4,
  fontFamily: "DM Sans",
  fontWeight: 700,
  fontSize: "13px",
  borderRadius: "12px",
};


export const headerSty = {
  fontFamily: "Lexend",
  fontWeight: 500,
};

export const textSty = {
  fontFamily: "DM Sans",
  fontSize: "15px",
  fontWeight: 700,
  lineHeight: "18px",
  textAlign: "left",
};